
import axios from "axios";
import { showErrorToast } from "../utils/toast/notificationPopup";
import { getAuthToken } from "../cognitoConfig";

export const attachAuthHeader = (headers: Record<string, string> = {}) => {
  const token = getAuthToken();
  return token ? { ...headers, Authorization: `Bearer ${token}` } : headers;
};


export const getService = (url: string, params?: any) => {
  return axios
    .get(url, {
      params: params,
      headers: attachAuthHeader({ "Content-Type": "application/json" }),
    })
    .then((response) => response.data);
};


export const postService = (url: string, body?: any) => {
  return axios
    .post(url, body, {
      headers: { ...attachAuthHeader(), "Content-Type": "application/json" },
    })
    .then((response) => response.data)
    .catch(() => {
      showErrorToast("Error");
    });
};
export const putService = (url: string, body?: any) => {
  return axios
    .put(url, body, {
      headers: { ...attachAuthHeader(), "Content-Type": "application/json" },
    })
    .then((response) => response.data);
};

export const deleteService = (url: string) => {
  return axios
    .delete(url, {
      headers: attachAuthHeader(),
    })
    .then((response) => response.data);
};

export const multiPartPostService = (url: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(url, formData, {
    headers: { ...attachAuthHeader(), "Content-Type": "multipart/form-data" },
  });
};

export const loadPartFile = (url: string) => {
  return axios({
    url,
    method: "GET",
    responseType: "arraybuffer",
    headers: { ...attachAuthHeader(), "Content-Type": "application/octet-stream" },
  }).then((response) => response.data);
};